import { Column } from '@smartsheet/core-views-api-models';
import { ReportRow } from '../../../common/interfaces/report';
import { getDisplayValue } from '../../../components/Grid/GridDataTransformer';

const SEPARATOR = ',';
const ENCLOSING_CHARACTER = '"';

const joiner = (row: string[]): string => {
    return row
        .map((element) => element ?? '')
        .map((column: string) => `${ENCLOSING_CHARACTER}${column}${ENCLOSING_CHARACTER}`)
        .join(SEPARATOR);
};

export const downloadCsvContent = (filename: string, csv: string) => {
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);

    // Generate a download link and initiate the download
    const link = document.createElement('a');
    link.href = url;
    link.download = `${filename}.csv`;
    document.body.appendChild(link);
    link.click();

    // Clean up by removing the link and revoking the object URL
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};

const generateCsvHeaderRow = (columns: Column[]): string => {
    return joiner(columns.map((column) => column.title));
};

const generateCsvDataRows = (rows: ReportRow[], userLocale: string, columns: Column[]) => {
    const csvRows: string[] = [];

    const columnMap = new Map<number, Column>(columns.map((column) => [column.id, column]));

    rows.forEach((row) => {
        const csvRow: string[] = [];
        const cellMap = new Map(row.cells.map((cell) => [cell?.reportColumnId, cell]));

        for (const [key, value] of columnMap.entries()) {
            let displayValue = '';
            const cell = cellMap.get(key);

            if (cell) {
                displayValue = getDisplayValue({ cell, column: value, userLocale });

                // Escape any double quotes in cell content by converting to 2x double quotes so that csv parser works as expected
                displayValue = displayValue.replace(/"/g, '""');
            }

            csvRow.push(displayValue);
        }

        csvRows.push(joiner(csvRow));
    });

    return csvRows;
};

export const generateCsvContent = (columns: Column[], rows: ReportRow[], userLocale: string): string => {
    const csvData = [];
    csvData.push(generateCsvHeaderRow(columns));
    csvData.push(...generateCsvDataRows(rows, userLocale, columns));

    return csvData.join('\n');
};
